import React from 'react';

import {
  CategoriesHeader,
  SecondaryButton,
  usePrice,
  LoyaltyBanner,
} from '@fingermarkglobal/cringer.components';
import { ArrowButton } from '../basket-action/';

const Header = ({
  title = null,
  total = null,
  className = '',
  showCategoriesHeader = true,
  previousAction = null,
  allowPreviousAction = true,
  isLogoEnabled = true,
  isTitleEnabled = true,
  nextAction = null,
  allowNextAction = true,
  nextActionClass = '',
  showSubtotal = true,
  couponText = 'Enter offer',
  isCouponEnabled = false,
  showCouponButton = false,
  couponAction = () => {},
  computedAction = () => {},
  accessibilityEnabled = false,
  showLoyaltyBanner = false,
} = {}) => {
  const { formatPrice } = usePrice();
  return (
    <div data-test="header" className={`flex flex-col bg-header text-white ${className}`}>
      {showCategoriesHeader && <CategoriesHeader isItemRounded={false} className="text-black" />}
      {showLoyaltyBanner && <LoyaltyBanner computedAction={computedAction} />}
      {!showCategoriesHeader && !accessibilityEnabled && (
        <div className={`flex justify-center md:mb-2 p-2 md:p-6`}>
          {isLogoEnabled && (
            <div className="w-full h-20 bg-center bg-no-repeat bg-contain md:w-1/2 md:h-32 bg-logo-horizontal md:bg-cover" />
          )}
        </div>
      )}
      <div className="flex justify-between p-1 bg-nav md:p-6">
        <div className="flex justify-start">
          {previousAction && (
            <ArrowButton
              disabled={!allowPreviousAction}
              onClick={previousAction}
              className="md:mr-6 header-button"
              isArrowInverse={true}
              isNextAction={false}
              data-test="arrow-back-button"
            />
          )}
        </div>
        <div className="self-center">
          {isTitleEnabled && (
            <h1 className="text-base font-bold text-center xs:text-2xl md:text-5xl font-header">
              {title}
            </h1>
          )}
        </div>
        <div className="flex justify-end md:space-x-4">
          {showSubtotal && (
            <p
              className="self-center hidden text-2xl font-bold text-center break-words md:text-5xl md:block"
              data-test="header-cart-subtotal"
            >
              {formatPrice({ price: total })}
            </p>
          )}
          {nextAction && (
            <ArrowButton
              disabled={!allowNextAction}
              onClick={nextAction}
              className={`md:ml-6 ${nextActionClass} header-button`}
              data-test="arrow-next-button"
            />
          )}
          {isCouponEnabled && showCouponButton && (
            <SecondaryButton
              className="ml-8 text-4xl font-bold"
              onClick={couponAction}
              data-test="enter-offer-button"
            >
              {couponText}
            </SecondaryButton>
          )}
        </div>
      </div>
    </div>
  );
};

export { Header };
